import _classCallCheck from "/builder/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builder/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builder/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builder/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { extension, PlainExtension, isDefaultDocNode, ManagerPhase } from '@remirror/core';
import { Decoration, DecorationSet } from '@remirror/pm/view';
import { ExtensionPlaceholderTheme } from '@remirror/theme';

var _dec, _class;

var PlaceholderExtension = (_dec = extension({
  defaultOptions: {
    emptyNodeClass: ExtensionPlaceholderTheme.IS_EMPTY,
    placeholder: ''
  }
}), _dec(_class = /*#__PURE__*/function (_PlainExtension) {
  _inherits(PlaceholderExtension, _PlainExtension);

  var _super = _createSuper(PlaceholderExtension);

  function PlaceholderExtension() {
    _classCallCheck(this, PlaceholderExtension);

    return _super.apply(this, arguments);
  }

  _createClass(PlaceholderExtension, [{
    key: "name",
    get: function get() {
      return 'placeholder';
    }
  }, {
    key: "createAttributes",
    value: function createAttributes() {
      return {
        'aria-placeholder': this.options.placeholder
      };
    }
  }, {
    key: "createPlugin",
    value: function createPlugin() {
      var _this = this;

      return {
        state: {
          init: function init(_, state) {
            return _objectSpread(_objectSpread({}, _this.options), {}, {
              empty: isDefaultDocNode(state.doc, {
                ignoreAttributes: true
              })
            });
          },
          apply: function apply(tr, pluginState, _, state) {
            return applyState({
              pluginState: pluginState,
              tr: tr,
              extension: _this,
              state: state
            });
          }
        },
        props: {
          decorations: function decorations(state) {
            return createDecorationSet({
              state: state,
              extension: _this
            });
          }
        }
      };
    }
  }, {
    key: "onSetOptions",
    value: function onSetOptions(props) {
      var changes = props.changes;

      if (changes.placeholder.changed && this.store.phase >= ManagerPhase.EditorView) {
        // update the attributes object
        this.store.updateAttributes();
      }
    }
  }]);

  return PlaceholderExtension;
}(PlainExtension)) || _class);
/**
 * Apply state for managing the created placeholder plugin.
 *
 * @param props
 */

function applyState(props) {
  var pluginState = props.pluginState,
      extension = props.extension,
      tr = props.tr,
      state = props.state;

  if (!tr.docChanged) {
    return pluginState;
  }

  return _objectSpread(_objectSpread({}, extension.options), {}, {
    empty: isDefaultDocNode(state.doc)
  });
}
/**
 * Creates a decoration set from the passed through state.
 *
 * @param props - see [[`SharedProps`]]
 */


function createDecorationSet(props) {
  var extension = props.extension,
      state = props.state;

  var _ref = extension.pluginKey.getState(state),
      empty = _ref.empty;

  var _extension$options = extension.options,
      emptyNodeClass = _extension$options.emptyNodeClass,
      placeholder = _extension$options.placeholder;

  if (!empty) {
    return;
  }

  var decorations = [];
  state.doc.descendants(function (node, pos) {
    var decoration = Decoration.node(pos, pos + node.nodeSize, {
      class: emptyNodeClass,
      'data-placeholder': placeholder
    });
    decorations.push(decoration);
  });
  return DecorationSet.create(state.doc, decorations);
}

export { PlaceholderExtension };